export interface AvatarPreset {
  id: string;
  name: string;
  emoji: string;
  color: string;
}

export const AVATAR_PRESETS: AvatarPreset[] = [
  { id: 'avatar-1', name: 'Professional', emoji: '👔', color: '#3b82f6' },
  { id: 'avatar-2', name: 'Student', emoji: '🎓', color: '#8b5cf6' },
  { id: 'avatar-3', name: 'Creative', emoji: '🎨', color: '#ec4899' },
  { id: 'avatar-4', name: 'Academic', emoji: '📚', color: '#10b981' },
  { id: 'avatar-5', name: 'Friendly', emoji: '😊', color: '#f59e0b' },
  { id: 'avatar-6', name: 'Confident', emoji: '💪', color: '#ef4444' },
  { id: 'avatar-7', name: 'Focused', emoji: '🎯', color: '#06b6d4' },
  { id: 'avatar-8', name: 'Ambitious', emoji: '🚀', color: '#6366f1' },
];

export function getAvatarPreset(value?: string | null): AvatarPreset | null {
  if (!value || typeof value !== 'string') return null;
  return AVATAR_PRESETS.find((preset) => preset.id === value.trim()) || null;
}
